module.exports = __webpack_public_path__ + "static/Aeroport-13f0a66a87436289f4d5180c86ecdcf3.woff2";